import React from 'react';

interface ShiftActionMenuProps {
    onRemoveSingle: () => void;
    onRemoveMultiple: () => void;
    onClose: () => void;
    openUpwards: boolean; 
}

const ShiftActionMenu: React.FC<ShiftActionMenuProps> = ({ onRemoveSingle, onRemoveMultiple, onClose, openUpwards }) => {
    const verticalPosition = openUpwards ? 'bottom-full mb-1' : 'top-full mt-1';

    return (
        <div 
            className={`absolute z-50 w-52 bg-white rounded-lg shadow-xl border border-gray-200 right-0 ${verticalPosition}`}
        >
            <button 
                onClick={onRemoveSingle}
                className="flex items-center text-base text-gray-800 hover:bg-gray-100 hover:text-gray-900 w-full text-left px-4 pt-3 pb-2 border-b"
            >
                <span className="text-xl mr-3">✕</span> Gỡ 1 ca
            </button>
            
            <button
                onClick={onRemoveMultiple}
                className="flex items-center text-base text-red-500 hover:bg-red-50 w-full text-left px-4 py-3 rounded-b-lg"
            >
                <span className="text-xl mr-3">🗑️</span> Gỡ nhiều ca
            </button>
        </div>
    );
};

export default React.memo(ShiftActionMenu);